import { render, staticRenderFns } from "./BlockContent.vue?vue&type=template&id=38938852&scoped=true"
import script from "./BlockContent.vue?vue&type=script&lang=js"
export * from "./BlockContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38938852",
  null
  
)

export default component.exports